"use client";

import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { useQuery } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";
import { ExamThemeProvider } from "@/contexts/ExamThemeContext";
import TextbookSidebar from "@/components/textbook/TextbookSidebar";
import TextbookMobileNav from "@/components/textbook/TextbookMobileNav";
import { useBoard } from "@/components/BoardProvider";

export default function TextbookLayout({ children }: { children: React.ReactNode }) {
  const board = useBoard();
  const navigationData = useQuery(api.textbook.topics.getNavigation, { board: board.shortName });
  const groupedTopics = navigationData?.groupedTopics;

  // Same shell as /dashboard: sidebar on the canvas, transparent header, and
  // the page in a floating panel that scrolls on its own. The page content
  // ({children}) is always rendered so it is present in the server HTML
  // (crawlable); the sidebar fills in once the client navigation query lands.
  return (
    <ExamThemeProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-sidebar">
        <div className="flex min-h-0 flex-1">
          <div className="hidden flex-shrink-0 md:block">
            <TextbookSidebar groupedTopics={groupedTopics} />
          </div>
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="h-16 flex-shrink-0 bg-transparent">
              <DashboardHeader hideLogoOnDesktop transparent>
                <TextbookMobileNav groupedTopics={groupedTopics} />
              </DashboardHeader>
            </div>
            <main className="flex min-h-0 flex-1 overflow-hidden md:px-4 md:pb-4">
              <div className="scrollbar-blend w-full overflow-y-auto rounded-3xl border-border bg-background md:border">
                {children}
              </div>
            </main>
          </div>
        </div>
      </div>
    </ExamThemeProvider>
  );
}
